import { createMissionUpdate } from '@module/helpers/centrifuge/messageUpdates';
import { missionListQueryKeys } from '@module/queries/mission/missionQuerykeys';
import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { isMissionMessage, type MissionMessage } from '@module/types/centrifuge/public-message/missionMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class MissionHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<MissionMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isMissionMessage(payload);
  }

  handle(payload: MissionMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.queryClient.invalidateQueries({ queryKey: missionListQueryKeys._def, exact: false });
    context.setPlayInfo(createMissionUpdate(payload, context.playInfo));
  }
}
